'use client'

import PropTypes from 'prop-types'
import { FormSearchAndSelect } from '@repo/form-components/FormSearchAndSelect'
import { useThirdPartyFormWizardStore } from '@repo/store/useThirdPartyFormWizardStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardPanel } from '@repo/ui/WizardPanel'

export const ThirdPartyFormSelectForm = ({ wideMode, handlePrevNext, updateStepState }) => {
  const { selectedMatter, selectedFormId, updateState } = useThirdPartyFormWizardStore()

  const handleClickContinue = () => {
    updateStepState({ status: 'completed' })
    handlePrevNext(1)
  }

  return (
    <>
      <WizardPanel data-testid="ThirdPartyFormSelectForm">
        <FormSearchAndSelect
          variant="radio"
          selectedFormIds={selectedFormId ?? ''}
          onSelectionChange={(formId) => updateState({ key: 'selectedFormId', value: formId })}
          workTypeId={selectedMatter?.workflowTypeId}
          sx={{ width: '100%' }}
        />
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        continueButtonText="Review data"
        handleClickBack={() => handlePrevNext(-1)}
        handleClickContinue={handleClickContinue}
        continueButtonDisabled={!selectedFormId}
      />
    </>
  )
}

ThirdPartyFormSelectForm.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  updateStepState: PropTypes.func
}
